#import "./HifoFields.graphql"
mutation EditHifo($id: ID!, $hifoInput: HifoChangeInput!, $comment: String) {
  updateHifo(input: { id: $id, hifoInput: $hifoInput, comment: $comment }) {
    hifo {
      ...HifoFields
    }
  }
}
